exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3VlazqYOv6Wt4zWyY7SXfG{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;overflow:hidden}", ""]);

// exports
exports.locals = {
	"compactRecipientRow": "_3VlazqYOv6Wt4zWyY7SXfG"
};